import React, {useEffect, useState} from "react";
import {Col, Row} from "reactstrap";
import Dialog from "../../base/dialog";
import Divider from "@mui/material/Divider";
import Button from "../../base/button/button";
import * as Yup from "yup";
import ValidateMessages from "../../../../core/models/static/texts/vallidate-messages";
import {makeRequired, makeValidate} from "mui-rff";
import Form from "../../base/form";
import useIsMounted from "../../../hooks/use-is-mounted";
import Api from "../../../../core/services/api/api";
import {OutlinedInputForm} from "../../base/input/outlined_input";


const schema = Yup.object().shape({
    rga: Yup.string().trim().nullable().required(ValidateMessages.required),
})

const subscription = {submitting: true, values: true, initialValues: true, submitErrors: true};

const ChangeWarrantyRGAModal = ({open, setOpen, onSuccess, request}) => {
    const [submitting, setSubmitting] = useState(false);
    const validate = makeValidate(schema);
    const required = makeRequired(schema);
    const [initialValues, setInitialValues] = useState({});
    const isMounted = useIsMounted();

    /**
     * Listens for the changes in request and with each change, sets the initialValues of the form data.
     */
    useEffect(() => {
        if (!request) return;
        setInitialValues({rga: request.rga?.toString()});
    }, [request])


    /**
     * Changes the status of a request, and if the new status is not same as the status of the request, then calls the
     * api to change it in the server too.
     * @param values {any}
     */
    const changeRga = (values) => {
        setSubmitting(true);
        const forApi = {
            partSupportId: request.id,
            newRga: values.rga,
        }
        Api.updateWarrantyAndReturnRga(forApi).then((response) => {
            if (!isMounted()) return;
            if (response?.resultFlag) {
                setOpen(false);
                onSuccess(request, values.rga);
            }
            if (!isMounted()) return;
            setSubmitting(false);
        })
    }
    return (
        <Dialog
            open={open}
            setOpen={setOpen}
        >
            <Row className='no-gutters justify-content-center align-items-start w-100'>
                <Row xs={12} className='no-gutters justify-content-center m-3 w-100'>
                    <p className={`text-lg text-color-1 my-2 font-weight-semi-bold text-center`}>
                        Change Request RGA
                    </p>
                </Row>
                <Divider className='divider'/>
                <div className='my-3 w-100'/>
                <Form
                    className='w-100'
                    onSubmit={changeRga}
                    subscription={subscription}
                    validate={validate}
                    initialValues={initialValues}
                    render={({values, form}) => {
                        return (
                            <Row className='no-gutters justify-content-around w-100'>
                                <Row className='no-gutters justify-content-around w-100 mx-4'>
                                    <Col xs={12} className={'mb-3 w-100'}>
                                        <p className={'text-color-3 text-sm mb-4'}>
                                            Please type in the new RGA for the selected request.
                                        </p>
                                    </Col>
                                    <Col xs={12} className='mb-4'>
                                        <OutlinedInputForm

                                            name={'rga'}
                                            label={'RGA'}
                                            required={required.rga}
                                            value={values?.rga ?? ''}
                                            onChange={(e) => form.change(e.target.name, e.target.value)}
                                        />
                                    </Col>
                                </Row>
                                <div className='my-2 w-100'/>
                                <Divider className='divider'/>
                                <Row className='no-gutters justify-content-between align-items-start w-100'>
                                    <Button
                                        disabled={!open || submitting}
                                        variant={'dialog'}
                                        color={'primary'}
                                        onClick={() => setOpen(false)}
                                        borderRadius={'0 8px 0 8px'}
                                    >
                                        {submitting ? 'submitting...' : 'Close'}
                                    </Button>
                                    <Button
                                        disabled={!open || submitting || request?.rga === values?.rga}
                                        variant={'dialog'}
                                        color={'primary'}
                                        type={'submit'}
                                        borderRadius={'8px 0 8px 0'}
                                    >
                                        {submitting ? 'submitting...' : 'Change'}
                                    </Button>
                                </Row>
                            </Row>
                        );
                    }}
                />
            </Row>
        </Dialog>
    );
}

export default ChangeWarrantyRGAModal;
